import HeroSlider from "@/components/site/HeroSlider";
import Marquee from "@/components/site/Marquee";
import ServicesChapters from "@/components/site/ServicesChapters";
import ReviewsCarousel from "@/components/site/ReviewsCarousel";
import MenuSection from "@/components/site/MenuSection";
import BlogSection from "@/components/site/BlogSection";
import ContactForm from "@/components/site/ContactForm";
import FaqSection from "@/components/site/FaqSection";
import { CtaSection, RichText, Gallery, InfoSection } from "@/components/site/Sections";

export default function PageRenderer({ page, settings, env, base = "" }) {
  if (!page) return null;
  return (
    <main data-testid={`page-${page.slug}`}>
      <HeroSlider slides={page.hero_slides || []} base={base} />
      {(page.sections || []).map((section, i) => {
        switch (section.type) {
          case "services": return <ServicesChapters key={i} section={section} base={base} />;
          case "marquee": return <Marquee key={i} items={settings?.marquee_items} />;
          case "reviews": return <ReviewsCarousel key={i} section={section} reviews={settings?.reviews || []} />;
          case "menu": return <MenuSection key={i} section={section} env={env} />;
          case "blog_preview": return <BlogSection key={i} section={section} env={env} base={base} preview />;
          case "blog_list": return <BlogSection key={i} section={section} env={env} base={base} />;
          case "contact_form": return <ContactForm key={i} section={section} />;
          case "faq": return <FaqSection key={i} section={section} />;
          case "cta": return <CtaSection key={i} section={section} base={base} />;
          case "richtext": return <RichText key={i} section={section} />;
          case "gallery": return <Gallery key={i} section={section} />;
          case "info": return <InfoSection key={i} section={section} />;
          default: return null;
        }
      })}
    </main>
  );
}
